import { render } from "./SecuritiesBasic.vue?vue&type=template&id=270efea9&scoped=true&ts=true"
import script from "./SecuritiesBasic.vue?vue&type=script&lang=ts"
export * from "./SecuritiesBasic.vue?vue&type=script&lang=ts"

import "./SecuritiesBasic.vue?vue&type=style&index=0&id=270efea9&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270efea9"]])

export default __exports__